module.exports = __webpack_public_path__ + "nc_static/media/sw-release-fail.a977d69a.svg";